import React, { useEffect, useState } from 'react'
import OpenModalButton from "../../components/OpenModalButton/OpenModalButton"
import FiltersModal from "../../components/FiltersModal/FiltersModal"
import FiltersListModal from "../../components/FiltersModal/FiltersListModal"
import { useDispatch } from "react-redux"
import { getFilters } from "../../features/customer/customerSlice"
import { showSnackBar } from "../Snackbar/Snackbar"
import { useMyContextLoading } from "../../components/LoadingContextProvider/LoadingContextProvider"
import { initQueryData } from "./helper"
import { LuListFilter, LuBookmark } from "react-icons/lu"
import { StorageGetItem, USER } from "../../lib/storage"
import { getContactGroupsForFilterUtils } from "../../features/contactGroups/contactGroups"
import { getAllAffiliatesForFilterUtils, getAllCustomUsersForFilterUtils, getUserStatusesForFilterUtils, getCreatorsForFilterUtils } from "../../features/user/user"
import { getAcquisitionSourcesForFilterUtils } from "../../features/customer/customerSlice"
import { getHistoryForFilterUtils, getHistoryCreatorsForFilterUtils } from "../../features/history/history"
import { getTaskStatusesForFilterUtils } from "../../features/tasks/tasks"
import { getLeadDispositions } from "../../features/customer/customerSlice"

const Filters = ({
                   fetchByFilterList,
                   fetchByFilters,
                   requestFilters,
                   isFilterList = true,
                   flow = 'contacts',
                   isContacts = false,
                   filterListId = null,
                   setFilterListId = null,
                   onFilterDataLoaded = null,
                 }) => {
  const dispatch = useDispatch()
  const { triggerBar } = useMyContextLoading()

  const [isOpenFilters, setIsOpenFilters] = useState(false)
  const [isOpenFilterList, setIsOpenFilterList] = useState(false)
  const [filters, setFilters] = useState([])
  const [utils, setUtils] = useState([])

  const [clickOnButton, setClickOnButton] = useState(false)
  const [userRole, setUserRole] = useState('')
  useEffect(() => {
    StorageGetItem(USER).then(result => {
      setUserRole(result?.role)
    })
  }, [])

  const handleFiltersIsOpen = (isOpen) => {
    setIsOpenFilters(isOpen)
    setIsOpenFilterList(false)
    setClickOnButton(true)
  }

  const handleFiltersListIsOpen = (isOpen) => {
    setIsOpenFilterList(isOpen)
    setIsOpenFilters(false)
    setClickOnButton(true)
  }

  const fetchFiltersFunction = async () => {
    triggerBar(true)
    try {
      const response = await dispatch(getFilters({ flow }))

      if (response?.payload?.data) {
        let { filters: resFilters, utils: resUtils } = response.payload.data
        const isContactGroupExists = resFilters?.some(el => el?.type === 'contactGroup')
        const isAffiliates = resFilters?.some(el => el?.type === 'affiliates')
        const isCustomUsersExists = resFilters?.some(el => el?.type === 'customUsers')
        const isUserStatusesExists = resFilters?.some(el => el?.type === 'userStatuses')
        const isHistoryActivityTypeExists = resFilters?.some(el => el?.type === 'historyType')
        const isTaskStatusesExists = resFilters?.some(el => el?.type === 'taskStatus')
        const isCreatorExists = resFilters?.some(el => el?.type === 'creator')
        const isHistoryCreatorsExists = resFilters?.some(el => el?.type === 'historyCreators')
        const isAcquisitionSourceExists = resFilters?.some(el => el?.type === 'acquisitionSource')
        const isLeadDispositionExists = resFilters?.some(el => el?.type === 'leadDisposition')

        if (!isContacts) {
          resFilters = resFilters?.filter(el =>
            el?.type !== 'userStatuses' &&
            el?.value !== 'enrollmentDate' &&
            el?.value !== 'contactPaymentPlanStatus' &&
            el?.value !== 'qcCallStatus' &&
            el?.value !== 'welcomeCallStatus'
          )
        }
        let finalUtils = resUtils || []

        if (!isContactGroupExists && !isUserStatusesExists && !isHistoryActivityTypeExists && !isAffiliates && !isTaskStatusesExists && !isCustomUsersExists && !isCreatorExists && !isHistoryCreatorsExists && !isAcquisitionSourceExists && !isLeadDispositionExists) {
          setUtils(finalUtils)
          if (onFilterDataLoaded) onFilterDataLoaded({ filters: resFilters, utils: finalUtils })
        } else {
          const utilPromises = []

          if (isContactGroupExists) {
            utilPromises.push(dispatch(getContactGroupsForFilterUtils()).then(r => r?.payload?.data || []))
          }
          if (isAffiliates && userRole !== 'affiliate') {
            utilPromises.push(dispatch(getAllAffiliatesForFilterUtils()).then(r => r?.payload?.data || []))
          }
          if (isCustomUsersExists) {
            utilPromises.push(dispatch(getAllCustomUsersForFilterUtils()).then(r => r?.payload?.data || []))
          }
          if (isUserStatusesExists) {
            utilPromises.push(dispatch(getUserStatusesForFilterUtils()).then(r => r?.payload?.data || []))
          }
          if (isHistoryActivityTypeExists) {
            utilPromises.push(dispatch(getHistoryForFilterUtils()).then(r => r?.payload?.data || []))
          }
          if (isTaskStatusesExists) {
            utilPromises.push(dispatch(getTaskStatusesForFilterUtils()).then(r => r?.payload?.data || []))
          }
          if (isCreatorExists) {
            utilPromises.push(dispatch(getCreatorsForFilterUtils()).then(r => r?.payload?.data || []))
          }
          if (isHistoryCreatorsExists) {
            utilPromises.push(dispatch(getHistoryCreatorsForFilterUtils()).then(r => r?.payload?.data || []))
          }
          if (isAcquisitionSourceExists) {
            utilPromises.push(dispatch(getAcquisitionSourcesForFilterUtils()).then(r => r?.payload?.data || []))
          }
          if (isLeadDispositionExists) {
            utilPromises.push(dispatch(getLeadDispositions()).then(r => {
              const dispositions = r?.payload?.data || []
              return dispositions.map(d => ({ _id: d._id, label: d.label, value: d._id, type: 'leadDisposition', isUtil: true, isValueNeeded: false }))
            }))
          }

          const utilResults = await Promise.all(utilPromises)
          for (const data of utilResults) {
            finalUtils = Array.from(new Map([...finalUtils, ...data].map(el => [el._id || `${el.type}:${el.value}`, el])).values())
          }

          setUtils(finalUtils)
          if (onFilterDataLoaded) onFilterDataLoaded({ filters: resFilters, utils: finalUtils })
        }

        setFilters(resFilters)
      }
    } catch (error) {
      showSnackBar("error", error)
    }

    triggerBar(false)
  }


  useEffect(() => {
    fetchFiltersFunction()
  }, [])

  return (
    <div>
      <div className="flex flex-row z-[999]">
        <div className="mr-4">
          <OpenModalButton label="Filters" icon={LuListFilter} isOpen={isOpenFilters}
                           setIsOpen={handleFiltersIsOpen}/>
        </div>
        {isFilterList && <div className="mr-4">
          <OpenModalButton label="Saved Filters" icon={LuBookmark} isOpen={isOpenFilterList}
                           setIsOpen={handleFiltersListIsOpen}/>
        </div>}
      </div>

      {isOpenFilters && <FiltersModal filters={filters} utils={utils} requestFilters={requestFilters}
                                      initQueryData={initQueryData}
                                      fetchFilters={fetchByFilters} setIsOpenFilters={setIsOpenFilters}
                                      isOpenFilters={isOpenFilters} setClickOnButton={setClickOnButton}
                                      clickOnButton={clickOnButton} setIsOpenFilterList={setIsOpenFilterList}
                                      isFilterList={isFilterList} userRole={userRole} setUtils={setUtils}
                                      flow={flow}
      />}


      {isFilterList && isOpenFilterList &&
        <FiltersListModal fetchFilters={fetchByFilterList} isOpenFilterList={isOpenFilterList}
                          setIsOpenFilterList={setIsOpenFilterList}
                          setClickOnButton={setClickOnButton}
                          clickOnButton={clickOnButton} setIsOpenFilters={setIsOpenFilters} flow={flow}
                          filterListId={filterListId} setFilterListId={setFilterListId}/>}

    </div>
  )
}

export default Filters
